export const Close = "Close";
export const Resize = "Resize";
export const SizeFormat = "Height {0}, Width {1}";
